import React, {useState, useEffect, useMemo} from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loading from '../../../../assets/svgs/loading.jsx';
import { X, UserList, Link, Check } from "@phosphor-icons/react";
import SingleUpload from '../../../../components/Uploader/single';
import isValidURL from '../../../../middleware/isValidUrl.jsx';
import Logo from '../../../../assets/images/logos/logo.png';
import {ClientSponsor} from '../../../../GraphQl/Conections/Query.ClientInfoProtected.js';
import UploadFile from '../../../../GraphQl/Conections/Mutation.UploadFile.jsx';
import {AddClientSponsor, RemoveClientSponsor} from '../../../../GraphQl/Conections/Mutation.ClientInfo.js';
import toast, { Toaster } from 'react-hot-toast';

export function Sponsor(props){
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [scrollPosition, setScrollPosition] = useState(false);
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [image, setImage] = useState(null);
    const [url, setUrl] = useState("");
    const [removeAvatar, setRemoveAvatar] = useState(false);
    const [removingIndex, setRemovingIndex] = useState(null);


    useEffect(() => {
        ClientSponsor(dispatch).then(data => {
            const sponsor = data.sponsor.filter(e => e.type == "1");
            setPartners(sponsor);
        })
    }, []);

    // Crea un URL per l'oggetto File
    const imagePreviewUrl = useMemo(() => {
        if (!image) return null;
        
        // Se è già un URL valido, usalo direttamente
        if (typeof image === 'string') {
            return isValidURL(image) ? image : process.env.REACT_APP_SERVER_IMAGE_ENDPOINT + "/public/images/dump/small-" + image;
        }
        
        // Se è un oggetto File, crea un URL
        if (image instanceof File) {
            return URL.createObjectURL(image);
        }
        
        return null;
    }, [image]);

    useEffect(() => {
        // Pulisci gli URL creati quando il componente viene smontato
        return () => {
            if (imagePreviewUrl && !isValidURL(image) && typeof image !== 'string') {
                URL.revokeObjectURL(imagePreviewUrl);
            }
        };
    }, [imagePreviewUrl, image]);

    

    const save = () => {
        setLoading(true);

        if(name.length == 0){
            setLoading(false);
            return;
        }
        if(image == null){
            setLoading(false);
            return;
        }
        // if(url.length == 0){
        //     setLoading(false);
        //     return;
        // }


        // Verifica che image sia un oggetto File
        if (image instanceof File) {
            
            const reader = new FileReader(); 
            reader.onloadend = () => { 
                // Crea il nuovo partner con l'immagine convertita in base64
                
                
                // Aggiorna lo stato dopo che l'immagine è stata caricata
                // setLoading(false);
                // setName("");
                // setImage(null);
                // setUrl("");

                UploadFile(dispatch, image).then(data => {
                    //Setta categoria nel db 
                    handleOk(data.uploadFile);
                })


                // setPartners([...partners, newPartner]);
            }; 
            reader.readAsDataURL(image);
        }


    }

    const handleOk = (uploadFile ) => {
        if(typeof uploadFile == "object"){
            uploadFile = undefined;
        }


        const newPartner = {
            sponsor_name: name,
            sponsor_src: url,
            sponsor_image_dump: uploadFile,
            type: "1",
        }
        
        AddClientSponsor(dispatch, newPartner).then(data => { 
            setTimeout(() => {

                toast.success("Sponsor Aggiunto", {
                    duration: 4000,
                    position: 'top-center',
                    // Styling
                    style: {},
                    className: 'dark:bg-slate-800 dark:text-slate-100',
                    // Custom Icon
                    icon: <Check className='text-green-500 w-10' size={20} />,
                });

                setLoading(false);
                setName("");
                setImage(null);
                setUrl("");
                setPartners([...partners, newPartner]);
                // navigate("/Menu/Articles");
            }, 1000);
        });
        
    }

    const removeItem = (partner, index) => {
        setRemovingIndex(index);
        RemoveClientSponsor(dispatch, partner._id).then(data => { 
            setTimeout(() => {

                toast.success("Sponsor Rimosso", {
                    duration: 4000,
                    position: 'top-center',
                    // Styling
                    style: {},
                    className: 'dark:bg-slate-800 dark:text-slate-100',
                    // Custom Icon
                    icon: <Check className='text-green-500 w-10' size={20} />,
                });

                setPartners(partners.filter((item, i) => i !== index));
                setRemovingIndex(null);
            }, 1000);
        });
    }

    return (
        <div>
            <div className='flex items-center justify-between p-4'>
                <div>
                    <p className='text-sm font-medium uppercase dark:text-slate-100'>Gestisci i tuoi espositori</p>
                    <p className="text-slate-400 text-xs  dark:text-slate-300">Modifica la lista dei tuoi espositori</p>
                </div>
            </div>
            <div className=" p-4">
                {/* Lista dei membri al partner */}
                <div className="divide-y divide-slate-100">
                    {
                        partners.length == 0 ? <div className="flex justify-center items-center h-10">
                            <p className="text-slate-400 text-sm dark:text-slate-300">Nessun partner trovato</p>
                        </div> 
                        :
                        partners.map((partner, i) => {
                            return (
                                <div key={i} className="py-4 flex justify-between items-center">
                                    <div className="flex space-x-2 items-center">
                                        <img className="size-14 rounded-xl object-cover object-center" 
                                             src={partner.sponsor_image_dump == null ? Logo : 
                                                  typeof partner.sponsor_image_dump === 'string' ? 
                                                  (isValidURL(partner.sponsor_image_dump) ? partner.sponsor_image_dump : process.env.REACT_APP_SERVER_IMAGE_ENDPOINT + "/public/images/dump/small-" + partner.sponsor_image_dump) : 
                                                  URL.createObjectURL(partner.sponsor_image_dump)} 
                                             alt={partner.sponsor_name} />
                                        <div className="flex flex-col">
                                            <div className="font-semibold">{partner.sponsor_name}</div>
                                            <div className="text-gray-600 text-xs">{partner.sponsor_src}</div>
                                        </div>
                                    </div>
                                    <div>
                                        <button 
                                            onClick={() => removeItem(partner, i)} 
                                            disabled={removingIndex === i}
                                            className={`border-slate-200 hover:border-purple-500 text-slate-700 dark:text-slate-200 hover:text-purple-600 dark:border-slate-700 dark:bg-slate-900 dark:hover:border-purple-500 dark:hover:text-purple-600 relative flex size-8 cursor-pointer items-center justify-center rounded-full border bg-white transition-colors duration-300 ${removingIndex === i ? 'opacity-50 cursor-not-allowed' : ''}`} 
                                            type="button" 
                                            tooltip="Remove">
                                            {removingIndex === i ? <Loading size={12} /> : <X size="15" weight='bold' />}
                                            <span className="sr-only">Remove</span>
                                        </button>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
               

                {/* Creazione del membro allo sponsor */}
                <div className="space-y-5">
                    <div className="mt-8">
                        <p className="text-md font-medium dark:text-slate-100">
                            Aggiungi uno espositori
                        </p>
                        <p className="text-slate-400 text-xs dark:text-slate-300">Aggiungi un nuovo espositore alla lista</p>
                    </div>
                    <div className="flex space-x-4">
                        <div>
                            <div className='relative flex flex-col items-center justify-center gap-4'>
                                <SingleUpload multiple={false} removeImage={(e) => setRemoveAvatar(e)} files={(file) => setImage(file[0])} defaultValue={image == null ? null : isValidURL(image) ? image : process.env.REACT_APP_SERVER_IMAGE_ENDPOINT + "/public/images/dump/small-" + image} />
                            </div>
                        </div>
                        <div className="flex flex-col space-y-4 w-full">
                            <div className="">
                                <div className='flex relative'>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        defaultValue={name}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="Nome dell'espositore"
                                        required
                                        className="peer pl-9 transition-all dark:bg-slate-900  dark:text-slate-100 focus-within:outline-offset-4 focus-within:outline-slate-400 focus-within:outline-dashed block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-slate-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    />
                                    <label htmlFor="name" className='peer-focus-within:text-indigo-600 text-slate-600'>
                                        <UserList className=' absolute top-2 left-2' size="20" weight='duotone' />
                                    </label>
                                </div>
                            </div>
                            <div className="">
                                <div className='flex relative'>
                                    <input
                                        id="url"
                                        name="url"
                                        type="text"
                                        defaultValue={url}
                                        value={url}
                                        onChange={(e) => setUrl(e.target.value)}
                                        placeholder='Url espositore: https://..'
                                
                                        className="peer pl-9 transition-all dark:bg-slate-900  dark:text-slate-100 focus-within:outline-offset-4 focus-within:outline-slate-400 focus-within:outline-dashed block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-slate-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    />
                                    <label htmlFor="name" className='peer-focus-within:text-indigo-600 text-slate-600'>
                                        <Link className=' absolute top-2 left-2' size="20" weight='duotone' />
                                    </label>
                                </div>
                            </div>
                            <div>
                                <button
                                    onClick={save}
                                    disabled={loading || name.length == 0 || url.length == 0 || image == null  }
                                    className="w-full rounded-md min-w-32 py-2 px-5 text-slate-100 bg-violet-500 border-violet-500 hover:bg-violet-500/50 hover:border-violet-500/50 relative"
                                >
                                    <span className={['flex justify-center items-center absolute -translate-x-2/4 left-2/4 transition-all', loading ? "translate-y-0 opacity-100" : "-translate-y-6 opacity-0"].join(" ")}><Loading /> Attendi...</span>
                                    <span className={['transition-all', loading ? "-translate-y-6 opacity-0" : "translate-y-0 opacity-100"].join(" ")}>Aggiungi</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}